import { ApplicationStep } from "@/enum/ApplicationStep";
import { getUrlStepFromApplicationStep } from "./url-utils";

export const isDebugForms = () => import.meta.env.VITE_APP_DEBUG_FORMS === "true";

const mainApplicantStepOrder: ApplicationStep[] = [
  ApplicationStep.User,
  ApplicationStep.Context,
  ApplicationStep.Applicant,
  ApplicationStep.ApplicantAddress,
  ApplicationStep.ApplicantID,
  ApplicationStep.ApplicantCurrentMortgage,
  ApplicationStep.ApplicantEmployment,
  ApplicationStep.ApplicantAssets,
  ApplicationStep.ApplicantLiabilities,
  ApplicationStep.ApplicantBankingDetails,
  ApplicationStep.SelfDeclaration,
  ApplicationStep.Review,
  ApplicationStep.Success,
];

/**
 * Returns the URL path for the next step in debug mode.
 */
export function getDebugNextStepUrl(
  applicationId: string,
  currentStep: ApplicationStep,
  applicantType: string = "main-applicant",
): string {
  const currentIndex = mainApplicantStepOrder.indexOf(currentStep);
  const nextStep =
    currentIndex >= 0 && currentIndex < mainApplicantStepOrder.length - 1
      ? mainApplicantStepOrder[currentIndex + 1]
      : ApplicationStep.Success;

  const segment = getUrlStepFromApplicationStep(nextStep);
  return `/application/${applicationId}/${segment}`;
}
